// Statsig dynamic config carrying the Host Hub marketing banner payloads
// (shared with mobile). Its value is `{ value: MarketingBannerConfig[] }`.
export const HOST_HUB_MARKETING_BANNERS_DYNAMIC_CONFIG_NAME =
  "host_hub_marketing_banners";

// `type` of the FSV Host Guide entry inside the config's `value` array.
export const FSV_HOST_GUIDE_BANNER_TYPE = "fsv";

export const DATE_BASED_PRICING_BANNER_TYPE = "date_based_pricing";

export const DATE_BASED_PRICING_USE_TYPES = [
  "Event",
  "Production",
  "Off-Site",
] as const;

export const US_COUNTRY_CODE = "US";
